import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Sidebar, WorkspaceHeader } from "./Workspace";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const reduced = useReducedMotion();
  useEffect(() => { window.scrollTo(0, 0); setMenuOpen(false); }, [pathname]);
  if (pathname.startsWith("/live/")) return <Outlet />;
  return (
    <div className="workspace">
      <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
      <div className="workspace-body">
        <WorkspaceHeader onMenu={() => setMenuOpen(true)} />
        <motion.main key={pathname} initial={{ opacity: reduced ? 1 : 0, y: reduced ? 0 : 5 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .22 }} className="workspace-main">
          <Outlet />
        </motion.main>
        <Footer />
      </div>
    </div>
  );
}